import { ChangeEvent, SyntheticEvent, useState, useEffect } from 'react'
import { Grid, SelectChangeEvent, useMediaQuery, useTheme } from '@mui/material'
import { useSearchParams } from 'react-router-dom'

// import { MobileFilter } from './mobile-filter.component'
import { SelectionFilters } from './selection-filter.component'
import { SearchBar } from '../search-bar'
import { IFilterProps } from './types/filter.types'

import useStyles from './styles'
import { FilterOffIcon } from 'src/assets/icons/v2/FilterOffIcon'
import { FilterIcon } from 'src/assets/icons/v2/FilterIcon'
import { useDebounce } from 'src/hooks'

const Filter = ({
  searchFieldText,
  filter,
  setFilter,
  sort,
  setSort,
  selectionOptions = [],
  sortOptions = [],
  checkboxOptions = [],
  initialState,
  noClear,
  isFilterOpened,
  showDateFilter = false,
  enableDebounce = false,
  debounceDelay = 500,
}: IFilterProps) => {
  const theme = useTheme()
  const isDesktop = useMediaQuery(theme.breakpoints.up('laptop_l'))
  const classes = useStyles()
  const [searchParams, setSearchParams] = useSearchParams()
  const [searchValue, setSearchValue] = useState(filter.query)

  const debouncedSearch = useDebounce(searchValue, debounceDelay)

  const [filterOpen, setFilterOpen] = useState(isFilterOpened || false)

  useEffect(() => {
    if (enableDebounce) {
      setFilter({ ...filter, query: debouncedSearch })
    }
  }, [debouncedSearch])

  useEffect(() => {
    searchParams.set('open', filterOpen.toString())
    setSearchParams(searchParams, { replace: true })
  }, [searchParams, filterOpen, setSearchParams])

  const handleSearchChange = (e: ChangeEvent<HTMLInputElement>) => {
    const next = e.target.value

    if (enableDebounce) {
      setSearchValue(next)
    } else {
      // immediate
      setFilter({ ...filter, query: next })
    }
  }

  const handleSelectChange = (queryName: string) => (e: SelectChangeEvent<string[]>) => {
    let value = e.target.value as string[]

    if (queryName === 'query') {
      const singleValue = value?.length ? value[0] : ''

      setFilter({ ...filter, query: singleValue })
      return
    }

    if (value.length >= 2 && value.includes('all')) {
      setFilter({ ...filter, [queryName]: value.filter((el) => el !== 'all') })
      return
    }
    if (!value[0]) {
      setFilter({ ...filter, [queryName]: ['all'] })
      return
    }
    setFilter({ ...filter, [queryName]: value })
  }

  const handleCheckboxChange = (e: SyntheticEvent) => {
    const target = e.target as HTMLInputElement
    const value = target.checked

    setFilter({ ...filter, [target.name]: value })
  }

  // const handleSortChange = (e: SelectChangeEvent<string>) => {
  //   setSort?.(e.target.value)
  // }

  const handleFilterOpen = () => {
    setFilterOpen((prev) => !prev)
  }

  return (
    <Grid item xs={12} className={classes.filterWrapper}>
      <Grid style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
        <div className={classes.searchBarWrapper}>
          <SearchBar
            search={enableDebounce ? searchValue : filter.query}
            handleSearchChange={handleSearchChange}
            inputPlaceholder={isDesktop ? searchFieldText : ''}
          />
          {(!!selectionOptions.length || !!checkboxOptions.length || showDateFilter) && (
            <div onClick={handleFilterOpen} className={classes.button}>
              {filterOpen ? <FilterIcon size={24} /> : <FilterOffIcon size={24} />}
            </div>
          )}
        </div>
        {filterOpen && (
          <SelectionFilters
            filter={filter}
            selectionOptions={selectionOptions}
            handleSelectChange={handleSelectChange}
            checkboxValues={checkboxOptions}
            handleCheckboxChange={handleCheckboxChange}
            setFilter={setFilter}
            showDateFilter={showDateFilter}
          />
        )}
        {/* <MobileFilter
          noClear={noClear}
          checkboxValues={checkboxOptions}
          handleCheckboxChange={handleCheckboxChange}
          sort={sort ?? ''}
          sortOptions={sortOptions}
          handleSortChange={handleSortChange}
          handleSelectChange={handleSelectChange}
          selectionOptions={selectionOptions}
          filter={filter}
          setFilter={setFilter}
        /> */}
        {/* {(!!selectionOptions.length || !!checkboxOptions.length) && (
          <SelectionFilters
            noClear={noClear}
            setFilter={setFilter}
            checkboxValues={checkboxOptions}
            handleCheckboxChange={handleCheckboxChange}
            handleSelectChange={handleSelectChange}
            selectionOptions={selectionOptions}
            filter={filter}
          />
        )} */}
      </Grid>
    </Grid>
  )
}

export { Filter }
